// extracted by mini-css-extract-plugin
export var stories = "styles-module--stories--2e18a";
export var story = "styles-module--story--2fd0d";